import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Collapse, IconButton, Typography, useMediaQuery } from '@mui/material';
import Link from '@mui/material/Link';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateForNotificationCard } from '../../utils/date.helpers';
import { useIsDesktop, useIsTablet } from '../../utils/mediaQueries';
import { parseNotificationContent } from '../../utils/notification.helper';
import { isObject } from '../../utils/object-helpers';
import { Card } from '../Card/Card';
import { Image } from '../Image/Image';
import { CardContent } from './CardContent';
import { APP_ROUTES } from './Routes';
import styles from './styles';
/* eslint-disable-next-line */
const NotificationCard = ({ content, dateSent, onCloseCard, readStatus, showCrossIcon, sectionName, isCarousel, }) => {
    const { i18n: { resolvedLanguage = 'en' } = {}, t: text } = useTranslation();
    const [showCard, setShowCard] = useState(true);
    const isDesktop = useIsDesktop();
    const isMobile = useMediaQuery('(max-width: 768px');
    const isTablet = useIsTablet();
    const formattedDate = formatDateForNotificationCard(dateSent, resolvedLanguage);
    const parsedContent = parseNotificationContent(content || '{}');
    const currentPillarName = window.location.href.split('/')[3] || ' ';
    const { title, message, data, cta } = parsedContent || {};
    const gaCTAAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0].toUpperCase() + currentPillarName.slice(1),
        'data-section-name': sectionName,
        'data-section-id': sectionName,
        'data-insight-id': 'Not applicable',
        'data-click-text': '',
        'data-type': 'CTA',
        click_url: '',
    };
    const gaButtonAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0]?.toUpperCase() + currentPillarName.slice(1),
        'data-section-name': sectionName,
        'data-section-id': sectionName,
        'data-insight-id': 'Not applicable',
        'data-click-text': 'Close Notification',
        'data-type': 'Button',
        'data-click-action': 'Close Notification',
    };
    const deleteNotification = () => {
        if (!readStatus) {
            setShowCard(false);
        }
        onCloseCard();
    };
    const renderTrashIcon = (readStatus = false) => (_jsx(IconButton, { sx: { padding: 0, mt: '-6px' }, onClick: deleteNotification, "data-testid": 'delete-notification-button', ...(readStatus && !showCrossIcon ? {} : { ...gaButtonAttributes }), children: readStatus && !showCrossIcon ? (_jsx(Image, { src: '/assets/images/trash-bin.svg', altTextKey: 'trash' })) : (_jsx(Image, { src: '/assets/images/close-icon.svg', altTextKey: 'close' })) }));
    const ctaLinkDetails = () => {
        if (!cta)
            return _jsx(_Fragment, {});
        const { routeKey, itemId } = cta;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const link = itemId ? `${APP_ROUTES[routeKey]}/${itemId}` : APP_ROUTES[routeKey];
        if (routeKey) {
            return (_jsxs(Link, { href: link, underline: 'hover', target: '_blank', variant: 'h5', sx: { display: 'flex', alignItems: 'center' }, onClick: !readStatus ? deleteNotification : () => { }, ...gaCTAAttributes, 'data-click-text': text(`${routeKey}`), click_url: link, children: [text(`${routeKey}`), _jsx(Image, { src: '/assets/images/left-arrow.svg', altTextKey: 'arrow' })] }));
        }
    };
    const isComplexCard = isObject(data) && Object.keys(data).length > 0;
    // comment for now as we need to fix theme.js breakpoints for whole repo
    // const isTabletOrMobile = isTablet || !isDesktop;
    const isLargeDesktop = isTablet || isDesktop;
    return (_jsx(Collapse, { in: showCard, sx: isCarousel ? {} : { mb: '1.5rem' }, children: _jsxs(Card, { sx: { ...styles.card({ isTablet, isCarousel, isComplexCard }) }, children: [_jsxs(Box, { children: [_jsxs(Box, { sx: { display: 'flex' }, children: [_jsxs(Box, { sx: { display: 'flex' }, children: [_jsx(Box, { sx: styles.iconContainer, children: _jsx(Image, { src: '/assets/images/blue-bulb.svg', altTextKey: 'bulb' }) }), _jsx(Typography, { variant: 'h5', sx: {
                                                textAlign: 'left',
                                                fontSize: `${isMobile ? '0.875' : '1.25'}rem`,
                                            }, children: title }), isLargeDesktop && (_jsx(Typography, { variant: 'body1', color: '#808285', sx: { ml: '1rem', pt: '2px', fontSize: '1.125rem' }, children: formattedDate }))] }), isMobile && (_jsx(Box, { sx: {
                                        flex: '1 0',
                                        display: 'flex',
                                        justifyContent: 'right',
                                        alignItems: 'flex-start',
                                    }, children: renderTrashIcon(readStatus) }))] }), isMobile && (_jsx(Box, { children: _jsx(Typography, { variant: 'body1', color: '#808285', sx: {
                                    pt: '0.5rem',
                                    display: 'flex',
                                    justifyContent: 'left',
                                    flex: '1 0',
                                    fontSize: '0.875rem',
                                }, children: formattedDate }) })), _jsx(Box, { sx: { ...styles.notificationBody, ...(isTablet && { width: '100%' }) }, children: _jsx(Typography, { variant: 'body1', sx: { fontSize: `${isMobile ? '0.875' : '1.125'}rem` }, children: message }) }), isMobile ? (_jsx(Box, { sx: styles.progressMobileContainer, children: _jsx(CardContent, { data: data }) })) : (_jsx(Box, {})), _jsx(Box, { sx: {
                                display: 'flex',
                                marginTop: {
                                    desktop: '-8px',
                                },
                            }, children: ctaLinkDetails() })] }), isLargeDesktop ? _jsx(CardContent, { data: data }) : _jsx(Box, {}), isLargeDesktop && _jsx(Box, { sx: { textAlign: 'right' }, children: renderTrashIcon(readStatus) })] }) }));
};
export default NotificationCard;
